"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import DOMPurify from "isomorphic-dompurify";
import { forwardRef } from "react";
import { Box } from "@mui/material";
import { SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
import { Alert } from "@nxt-costco-com/forge-icons";
import { Text } from "../../DataDisplay/Text/index.js";
import { INVALID_PROPS_ERROR, INVALID_MESSAGE_ERROR, NOTIFICATION_COLOR_MAP, COMPONENT_NAME } from "./constants.js";
import { NotificationTypes } from "./enums.js";
import { StyledFlexBox, StyledIconBox, StyledText } from "./styles.js";
import { getDataTestId } from "../../Util/index.js";
const Notification = forwardRef(
  ({
    icon,
    message,
    title,
    severity = "general",
    sx,
    isRole,
    suffix = "",
    uniqueId = ""
  }, ref) => {
    if (!message) {
      console.error(INVALID_PROPS_ERROR);
      return null;
    }
    const sanitizedMessage = DOMPurify.sanitize(message);
    if (!sanitizedMessage) {
      console.error(INVALID_MESSAGE_ERROR);
      return null;
    }
    const defaultRole = severity === NotificationTypes.GENERAL ? "" : NotificationTypes.ALERT;
    const roleApplied = isRole ? NotificationTypes.ALERT : "";
    const role = isRole === void 0 ? defaultRole : roleApplied;
    const roleAttribute = {
      ...role && { role: NotificationTypes.ALERT }
    };
    const notificationColor = NOTIFICATION_COLOR_MAP[severity];
    const isCriticalAlert = severity === NotificationTypes.CRITICAL;
    return /* @__PURE__ */ jsxs(
      StyledFlexBox,
      {
        sx,
        ref,
        tabIndex: -1,
        id: `${severity}-message` + suffix,
        color: notificationColor,
        "data-testid": getDataTestId(COMPONENT_NAME, uniqueId),
        ...roleAttribute,
        children: [
          (isCriticalAlert || icon) && /* @__PURE__ */ jsx(StyledIconBox, { children: isCriticalAlert ? /* @__PURE__ */ jsx(Alert, {}) : icon }),
          /* @__PURE__ */ jsxs(Box, { children: [
            title && /* @__PURE__ */ jsx(
              Text,
              {
                variant: "t4-v2",
                bold: true,
                sx: { marginBottom: SpaceXxs },
                uniqueId: getDataTestId(uniqueId, "title"),
                children: title
              }
            ),
            /* @__PURE__ */ jsx(
              StyledText,
              {
                variant: "b2",
                sx: { color: notificationColor.color },
                uniqueId: getDataTestId(uniqueId, "message"),
                children: typeof message === "string" ? /* @__PURE__ */ jsx(
                  "div",
                  {
                    dangerouslySetInnerHTML: {
                      __html: sanitizedMessage
                    }
                  }
                ) : message
              }
            )
          ] })
        ]
      }
    );
  }
);
Notification.displayName = COMPONENT_NAME;
export {
  Notification
};
